/**
 * DIFF-7 seed — HS classifications, tariff alerts, landed-cost snapshots.
 */
import { DEMO_TENANT_ID } from './tenantDefaults';

const T = DEMO_TENANT_ID;
const iso = (days = 0, hours = 0) => new Date(Date.now() - (days * 86400000 + hours * 3600000)).toISOString();
const future = (days = 0) => new Date(Date.now() + days * 86400000).toISOString();

export const SEED_HS_CLASSIFICATIONS = [
  { id: 'hs-0001', tenantId: T, itemId: 'item-battery',    itemDescription: 'Lithium-ion battery pack 3.7V 5000mAh', hsCode: '850760', description: 'Lithium-ion batteries',     confidence: 0.91, mock: false, classifiedAt: iso(3), isDeleted: false, createdAt: iso(3), updatedAt: iso(3), version: 1, source: 'tariff_impact_engine' },
  { id: 'hs-0002', tenantId: T, itemId: 'item-panel',      itemDescription: 'Monocrystalline solar panel 450W',      hsCode: '854140', description: 'Photovoltaic cells',        confidence: 0.88, mock: false, classifiedAt: iso(3), isDeleted: false, createdAt: iso(3), updatedAt: iso(3), version: 1, source: 'tariff_impact_engine' },
  { id: 'hs-0003', tenantId: T, itemId: 'item-steel',      itemDescription: 'Carbon steel rebar grade 60',           hsCode: '720610', description: 'Iron/steel ingots',         confidence: 0.84, mock: true,  classifiedAt: iso(5), isDeleted: false, createdAt: iso(5), updatedAt: iso(5), version: 1, source: 'tariff_impact_engine' },
  { id: 'hs-0004', tenantId: T, itemId: 'item-fabric',     itemDescription: '100% organic cotton twill fabric',      hsCode: '520100', description: 'Cotton/woven fabric',       confidence: 0.78, mock: true,  classifiedAt: iso(7), isDeleted: false, createdAt: iso(7), updatedAt: iso(7), version: 1, source: 'tariff_impact_engine' },
  { id: 'hs-0005', tenantId: T, itemId: 'item-chair',      itemDescription: 'Office desk chair — solid oak frame',   hsCode: '940360', description: 'Wooden furniture',          confidence: 0.72, mock: true,  classifiedAt: iso(9), isDeleted: false, createdAt: iso(9), updatedAt: iso(9), version: 1, source: 'tariff_impact_engine' },
];

export const SEED_TARIFF_ALERTS = [
  {
    id: 'ta-0001', tenantId: T,
    hsCode: '850760', change: 7.5, effectiveDate: future(14),
    sourceUrl: 'https://www.federalregister.gov/documents/tariff-850760',
    noticedAt: iso(0, 4), status: 'open',
    isDeleted: false, createdAt: iso(0, 4), updatedAt: iso(0, 4), version: 1, source: 'tariff_impact_engine',
  },
  {
    id: 'ta-0002', tenantId: T,
    hsCode: '720610', change: -2.0, effectiveDate: future(21),
    sourceUrl: 'https://www.federalregister.gov/documents/tariff-720610',
    noticedAt: iso(1), status: 'open',
    isDeleted: false, createdAt: iso(1), updatedAt: iso(1), version: 1, source: 'tariff_impact_engine',
  },
];

// Landed cost snapshots — realistic PO impact showing tariff line items
export const SEED_LANDED_COST_SNAPSHOTS = [
  {
    id: 'lcs-0001', tenantId: T,
    poId: 'po-battery-001', poNumber: 'PO-2026-0188',
    itemId: 'item-battery', itemDescription: 'Lithium-ion battery pack 3.7V 5000mAh',
    hsCode: '850760', tariffRate: 12.5,
    goods: 250000, freight: 8400, insurance: 1250, tariff: 31250, customsFee: 285, total: 291185,
    perUnit: 291.185, alertId: 'ta-0001', alertChange: 7.5,
    snapshotAt: iso(0, 2),
    isDeleted: false, createdAt: iso(0, 2), updatedAt: iso(0, 2), version: 1, source: 'tariff_impact_engine',
  },
  {
    id: 'lcs-0002', tenantId: T,
    poId: 'po-battery-001', poNumber: 'PO-2026-0188',
    itemId: 'item-battery', itemDescription: 'Lithium-ion battery pack 3.7V 5000mAh (post-alert)',
    hsCode: '850760', tariffRate: 20.0,
    goods: 250000, freight: 8400, insurance: 1250, tariff: 50000, customsFee: 285, total: 309935,
    perUnit: 309.935, alertId: 'ta-0001', alertChange: 7.5,
    snapshotAt: iso(0, 1),
    isDeleted: false, createdAt: iso(0, 1), updatedAt: iso(0, 1), version: 1, source: 'tariff_impact_engine',
  },
  {
    id: 'lcs-0003', tenantId: T,
    poId: 'po-steel-004', poNumber: 'PO-2026-0192',
    itemId: 'item-steel', itemDescription: 'Carbon steel rebar grade 60',
    hsCode: '720610', tariffRate: 6.0,
    goods: 180000, freight: 12200, insurance: 900, tariff: 10800, customsFee: 190, total: 204090,
    perUnit: 13.606, alertId: 'ta-0002', alertChange: -2.0,
    snapshotAt: iso(1),
    isDeleted: false, createdAt: iso(1), updatedAt: iso(1), version: 1, source: 'tariff_impact_engine',
  },
  {
    id: 'lcs-0004', tenantId: T,
    poId: 'po-panel-002', poNumber: 'PO-2026-0189',
    itemId: 'item-panel', itemDescription: 'Monocrystalline solar panel 450W',
    hsCode: '854140', tariffRate: 3.5,
    goods: 340000, freight: 22000, insurance: 1700, tariff: 11900, customsFee: 410, total: 376010,
    perUnit: 940.025, alertId: null, alertChange: null,
    snapshotAt: iso(2),
    isDeleted: false, createdAt: iso(2), updatedAt: iso(2), version: 1, source: 'tariff_impact_engine',
  },
];

export const TARIFF_SEED_SUMMARY = {
  hs_classifications: SEED_HS_CLASSIFICATIONS.length,
  tariff_alerts: SEED_TARIFF_ALERTS.length,
  landed_cost_snapshots: SEED_LANDED_COST_SNAPSHOTS.length,
};
